import React from "react";
import ReactPlayer from "react-player";
import { YouTubePlayer } from "shared";

export const CourseTaskVideo = ({ contentType, fileURL }) => {
  const videoLinkContentType = 2;

  const isYouTubeLink = contentType === videoLinkContentType;

  return (
    <div className="iframe-container mb-4">
      {isYouTubeLink ? (
        <YouTubePlayer videoUrl={fileURL} />
      ) : (
        <ReactPlayer
          className="responsive-iframe"
          url={fileURL}
          width="100%"
          height="100%"
          controls
          config={{
            file: {
              attributes: {
                disablePictureInPicture: true,
                controlsList: "nodownload",
              },
            },
          }}
        />
      )}
    </div>
  );
};
